import React, { useState, useEffect } from 'react';
import { Settings, Bell, Shield, X, Save } from 'lucide-react';
import { http } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';

export default function Configuracion({ isOpen, onClose }) {
  const { user } = useAuth();
  const [configuracion, setConfiguracion] = useState({
    notificaciones: {
      email: true,
      push: true,
      ordenes: true,
      recordatorios: true
    },
    privacidad: {
      perfilPublico: false,
      mostrarEstado: true
    }
  });
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje] = useState('');

  // Cargar configuración cuando se abre el modal
  useEffect(() => {
    if (isOpen && user) {
      cargarConfiguracion();
    }
  }, [isOpen, user]);

  const cargarConfiguracion = async () => {
    try {
      setCargando(true);
      const token = localStorage.getItem('token');
      const response = await http.get('/perfil/configuracion', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Actualizar estado con la configuración del servidor
      if (response.data) {
        setConfiguracion({
          notificaciones: {
            email: response.data.notificaciones?.email ?? true,
            push: response.data.notificaciones?.push ?? true,
            ordenes: response.data.notificaciones?.ordenes ?? true,
            recordatorios: response.data.notificaciones?.recordatorios ?? true
          },
          privacidad: {
            perfilPublico: response.data.privacidad?.perfil_publico ?? false,
            mostrarEstado: response.data.privacidad?.mostrar_estado ?? true
          }
        });

        // Eliminar lógica de tema
      }
    } catch (error) {
      console.error('Error cargando configuración:', error);
      setMensaje('Error al cargar la configuración');
    } finally {
      setCargando(false);
    }
  };

  const handleConfigChange = (seccion, campo, valor) => {
    setConfiguracion(prev => {
      if (seccion) {
        return {
          ...prev,
          [seccion]: {
            ...prev[seccion],
            [campo]: valor
          }
        };
      } else {
        return {
          ...prev,
          [campo]: valor
        };
      }
    });
  };

  const guardarConfiguracion = async () => {
    setGuardando(true);
    setMensaje('');

    try {
      const token = localStorage.getItem('token');
      
      // Preparar datos para enviar al backend
      const datosConfiguracion = {
        notificaciones: configuracion.notificaciones,
        privacidad: {
          perfil_publico: configuracion.privacidad.perfilPublico,
          mostrar_estado: configuracion.privacidad.mostrarEstado
        }
      };

      // Enviar al backend
      await http.put('/perfil/configuracion', datosConfiguracion, {
        headers: { Authorization: `Bearer ${token}` }
      });

  // También guardar en localStorage para uso inmediato
  localStorage.setItem('idioma', configuracion.idioma);
      localStorage.setItem('notif_email', JSON.stringify(configuracion.notificaciones.email));
      localStorage.setItem('notif_push', JSON.stringify(configuracion.notificaciones.push));
      localStorage.setItem('notif_ordenes', JSON.stringify(configuracion.notificaciones.ordenes));
      localStorage.setItem('notif_recordatorios', JSON.stringify(configuracion.notificaciones.recordatorios));
      localStorage.setItem('perfil_publico', JSON.stringify(configuracion.privacidad.perfilPublico));
      localStorage.setItem('mostrar_estado', JSON.stringify(configuracion.privacidad.mostrarEstado));

      // Eliminar lógica de tema

      setMensaje('Configuración guardada correctamente');
      
      setTimeout(() => {
        setMensaje('');
      }, 3000);

    } catch (error) {
      console.error('Error guardando configuración:', error);
      const mensajeError = error.response?.data?.detail || 'Error al guardar la configuración';
      setMensaje(mensajeError);
    } finally {
      setGuardando(false);
    }
  };

  // Eliminar lógica de tema

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-xl w-full max-w-lg mx-4 max-h-[90vh] overflow-hidden border border-gray-200 dark:border-gray-700">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <Settings size={20} />
            Configuración
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Contenido */}
  <div className="overflow-y-auto max-h-[calc(90vh-140px)]">
          {cargando ? (
            <div className="flex items-center justify-center py-12">
              <div className="text-center">
                <div className="animate-spin w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full mx-auto mb-3"></div>
                <p className="text-gray-500">Cargando configuración...</p>
              </div>
            </div>
          ) : (
            <div className="p-6 space-y-6">
            
            {/* Apariencia: Eliminada opción de tema */}

            {/* Idioma: Eliminada opción de idiomas */}

            {/* Notificaciones */}
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <Bell size={16} />
                Notificaciones
              </h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700">Notificaciones por email</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={configuracion.notificaciones.email}
                      onChange={(e) => handleConfigChange('notificaciones', 'email', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>
                
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700 dark:text-gray-200">Notificaciones push</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={configuracion.notificaciones.push}
                      onChange={(e) => handleConfigChange('notificaciones', 'push', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>
                
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700 dark:text-gray-200">Nuevas órdenes</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={configuracion.notificaciones.ordenes}
                      onChange={(e) => handleConfigChange('notificaciones', 'ordenes', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>
                
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700 dark:text-gray-200">Recordatorios</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={configuracion.notificaciones.recordatorios}
                      onChange={(e) => handleConfigChange('notificaciones', 'recordatorios', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>
              </div>
            </div>

            {/* Privacidad */}
            <div>
              <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                <Shield size={16} />
                Privacidad
              </h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-sm text-gray-700 dark:text-gray-200">Perfil público</span>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Permite que otros usuarios vean tu perfil</p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={configuracion.privacidad.perfilPublico}
                      onChange={(e) => handleConfigChange('privacidad', 'perfilPublico', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>
                
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-sm text-gray-700 dark:text-gray-200">Mostrar estado online</span>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Indica cuando estás conectado</p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={configuracion.privacidad.mostrarEstado}
                      onChange={(e) => handleConfigChange('privacidad', 'mostrarEstado', e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                  </label>
                </div>
              </div>
            </div>

            {/* Mensaje */}
            {mensaje && (
              <div className={`p-3 rounded-lg text-sm ${
                mensaje.includes('Error') ? 'bg-red-50 dark:bg-red-900 text-red-600 dark:text-red-200' : 'bg-green-50 dark:bg-green-900 text-green-600 dark:text-green-200'
              }`}>
                {mensaje}
              </div>
            )}
          </div>
          )}
        </div>

        {/* Footer */}
  <div className="p-6 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={guardarConfiguracion}
            disabled={guardando}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-800 transition-colors disabled:opacity-50"
          >
            {guardando ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <Save size={16} />
            )}
            Guardar configuración
          </button>
        </div>
      </div>
    </div>
  );
}